<template>

    <section class="history">
        <div class="flex content-narrow-width">
            <ul class='timeline' v-bind:style="verticalLineStyle">
                <div class="timeline">
                    <div class="event"
                         v-for="(event, index) in histories"
                         :class="{'offset-first':index == 0}">


                        <img :src="event.image" :alt="event.title">
                        <div class="content"
                             v-bind:ref="'content'+index"
                             id="content"
                        >
                            <h4>{{ event.title }}</h4>
                            <p v-if="event.lead_copy">{{ event.lead_copy }}</p>
                            <a href="#" class="read-more" @click.prevent="toggleModal(index)">Read More</a>
                        </div>

                    </div>
                </div>
            </ul>

            <portal v-if="showingModal" to="modal">
                <app-modal @close="toggleModal" class="history">
                    <div class="flex flex-start">
                        <img :src="activeEvent.image" :alt="activeEvent.title">
                        <div class="description">
                            <h4>{{ activeEvent.title }}</h4>
                            <div class="wysiwyg" v-html="activeEvent.content"></div>
                        </div>
                    </div>
                </app-modal>
            </portal>
        </div>
    </section>

</template>
<script>
export default {
  props: {
    histories: Array
  },
  data () {
    return {
      showingModal: false,
      historyLength: this.histories.length - 1,
      refText: 'content' + (this.histories.length - 1),
      verticalLineStyle: { },
      activeEvent: {
          title: '',
          image: '',
          content: ''
      }
    }
  },
  methods: {
    toggleModal (index) {
      this.showingModal = ! this.showingModal

      if(index !== null) {
        this.activeEvent.title = this.histories[index].title
        this.activeEvent.image = this.histories[index].image
        this.activeEvent.content = this.histories[index].content
      }
        document.body.style.overflow = "hidden";
    },
    getContentHeight () {
      var content = 'content' + this.historyLength
      var heightString = (this.$refs[content][0].clientHeight + 30) + 'px'
      Vue.set(this.verticalLineStyle, 'background-size', '5px calc(100% - ' + heightString + '), contain')
    }
  },

    mounted() {
      this.getContentHeight();
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HistoryCard.vue